import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=1f88a46c&scoped=true&"
import script from "./UnitList.vue?vue&type=script&lang=js&"
export * from "./UnitList.vue?vue&type=script&lang=js&"
import style0 from "./UnitList.vue?vue&type=style&index=0&id=1f88a46c&lang=scss&scoped=true&"
import style1 from "./UnitList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88a46c",
  null
  
)

export default component.exports